import { useTranslation } from 'react-i18next';
import React, {useEffect,useRef, useState} from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { Grid, Card, Button, Table, TableRow, TableBody, Box, TableCell, TableContainer,} from '@mui/material'
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import { useMessage } from "../../context/message-context";
import Projektstundenverteilung from "../Projektstundenverteilung";
import ProjektstundenAuswertung from "../ProjektstundenAuswertung";
import { Routes, Route} from "react-router-dom";
import { SearchTextField } from "../lib";
function ProjektstundenAdmin(props) {
  const { t } = useTranslation();
  const {client, accessToken, updateTitle} = props;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {showErrorMessage} = useMessage();
  const [user,setUser]=useState([]);
  const [open,setOpen]=useState("");
  const admin="J"
  const userid=useRef("")
  const [filter,setFilter]=useState("")
  useEffect(() => {
    updateTitle("Projektstundenverteilung - Administrator")
    setIsLoading(true);
    const payload={
      "mandant": client, // this.props.client,
      "program": "PPROJ3",
      "statement": "UEBERSICHT",
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, postUebersicht);
    // eslint-disable-next-line
  }, [])
  const postUebersicht=(response)=>{
    setIsLoading(false);
    if (response.status === 200) {
        setUser(response.data.user);
    } else {
        if (response) {
            showErrorMessage(response.data.message);
        } else {
            showErrorMessage(t("Keine Internetverbindung"));
        }
    }
  }
  if (isLoading) {
    return <LoadingComponent path={props.location}/>
  }
  function Aktion(aktion){
    if (aktion==="aktiv"){
        setOpen("A");
    }
    if (aktion==="inaktiv"){
        setOpen("I");
    }
    if (aktion==="auswertung"){
        navigate('auswertung')
    }
  }
  function AuswahlUser(user){
    userid.current=user;
    setOpen("");
    navigate('PPROJN')
  }
    function Admin(){
        return(
            <Grid container justifyContent="center" spacing={2}>
            {Auswahl()}
            <Grid item xs={12} md={8}>
                <Card>
                    <Box p={2}>
                        <Grid container justifyContent="center" spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={()=>Aktion("aktiv")}
                                    color="primary"
                                >
                                    {t("Nur aktive Personen anzeigen")}
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={()=>Aktion("inaktiv")}
                                    color="primary"
                                >
                                    {t("Nur inaktive Personen anzeigen")}
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={()=>Aktion("auswertung")}
                                    color="primary"
                                >
                                    {t("Auswertung von Projekten")}
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Card>
            </Grid>
        </Grid>
        )
    }
    function Auswahl(){
        return(
            <ResponsiveDialog 
                title={t("Auswahl Mitarbeiter")}
                open={open==="A"||open==="I"} 
                setOpen={(o) => {setOpen("");setFilter("")}}
            >
                <Box p={2}>
                <SearchTextField
                            fullWidth
                            label={t("Suche")}
                            id="filter2"
                            variant="outlined"
                            value={filter}
                            inputProps={{
                            autoCapitalize: 'off',
                            autoCorrect: 'off',
                            spellCheck: 'false',
                            autoComplete: 'off'
                            }}
                            onChange={(e)=>setFilter(e.target.value)}
                        />
                </Box>
                <TableContainer>
                <Table>
                    <TableBody>
                        {(user&&user.length>0)&&user.filter((item) => {
                            if (open==="A"&&item.aktiv==="N") return false
                            if (open==="I"&&item.aktiv==="J") return false
                            if (item.name.toLowerCase().includes(filter.toLowerCase())===false) return false;
                            return true
                        }).map((item)=>{
                            return(
                            <TableRow
                                style={{cursor: 'pointer'}}
                                onClick={() => AuswahlUser(item.user) }
                                hover
                            >
                                <TableCell>
                                    {item.name}
                                </TableCell>
                            </TableRow>
                            )
                        })}
                        {(!user||user.length<=0)&&
                            <TableRow><TableCell>{t("Es stehen keine Mitarbeiter zur Auswahl")}</TableCell></TableRow>
                        }
                    </TableBody>
                </Table>
                </TableContainer>
            </ResponsiveDialog>
        )
    }
    return (  
        <Routes>
            <Route path="/PPROJN/*" element={<Projektstundenverteilung updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} admin={admin} userid={userid.current}/>} />  
            <Route path="/auswertung" element={<ProjektstundenAuswertung updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} admin={admin} userid={userid.current}/>} />  
            <Route path="/" element={Admin()}/>
        </Routes>  
    );
  }
export default ProjektstundenAdmin;
